module.exports = __webpack_public_path__ + "img/plus-square.ce719d87.svg";